export const getDurationString = (startDate, endDate) => {
    if (!startDate || !endDate) return null;

    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();

    if (Number.isNaN(start) || Number.isNaN(end) || end < start) return null;

    const minutes = Math.round((end - start) / 60000);

    if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"}`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"}`;

    const days = Math.floor(hours / 24);
    return `${days} day${days === 1 ? "" : "s"}`;
};

export const formatElapsed = (seconds) => {
    const safeSeconds = Math.max(0, Number(seconds) || 0);
    const h = Math.floor(safeSeconds / 3600);
    const m = Math.floor((safeSeconds % 3600) / 60);
    const s = safeSeconds % 60;

    return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
};

export const resolveWorkerStatus = (workforceEvent = {}) => {
    const normalizedStatus = String(workforceEvent?.status ?? "").toLowerCase();
    const { startAt, endAt } = workforceEvent;

    const isCompleted =
        normalizedStatus === "completed" || (!!startAt && !!endAt);

    const isInProgress =
        !isCompleted &&
        (normalizedStatus === "inprogress" ||
            normalizedStatus === "in_progress" ||
            (!!startAt && !endAt));

    return { isCompleted, isInProgress };
};